import React, { FunctionComponent, memo } from 'react';
import { Box, BoxProps, CircularProgress } from '@material-ui/core';
import overlayLoaderStyles from './overlayLoaderStyles';

interface IOverlayLoaderProps extends BoxProps {
  loading?: boolean;
}

const OverlayLoader: FunctionComponent<IOverlayLoaderProps> = memo(({ children, loading, ...props }) => {
  const styles = overlayLoaderStyles();

  return (
    <Box position={'relative'} {...(loading ? { 'data-test': 'container:loader:overlay' } : {})} {...props}>
      {children}
      {loading && (
        <Box className={styles.loaderContainer}>
          <Box className={styles.progressContainer}>
            <CircularProgress size={50} />
          </Box>
        </Box>
      )}
    </Box>
  );
});

export default OverlayLoader;
